// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { AiApiSpec_emptySchema } from './AiApiSpec_emptySchema';
import { AiApiSpec_generateNoteQueueRequestBodySchema } from './AiApiSpec_generateNoteQueueRequestBodySchema';

/**
 * @description 200 response
 */
export const AiApiSpec_addToGenerateNoteQueue200Schema = z.lazy(() => AiApiSpec_emptySchema);

export const AiApiSpec_addToGenerateNoteQueueMutationRequestSchema = z.lazy(() => AiApiSpec_generateNoteQueueRequestBodySchema);

export const AiApiSpec_addToGenerateNoteQueueMutationResponseSchema = z.lazy(() => AiApiSpec_addToGenerateNoteQueue200Schema);
